import { useCallback, useState } from "react";

/**
 * Intercepts backdrop / escape attempts to close a form modal and shows a confirmation first.
 */
export function useFormCloseGuard({ onLeave }) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const requestLeave = useCallback(() => {
    setConfirmOpen(true);
  }, []);

  const confirmLeave = useCallback(() => {
    setConfirmOpen(false);
    onLeave();
  }, [onLeave]);

  const cancelLeave = useCallback(() => {
    setConfirmOpen(false);
  }, []);

  const handleBackdropClick = useCallback(
    (event, reason) => {
      if (reason === "backdropClick" || reason === "escapeKeyDown") {
        requestLeave();
      }
    },
    [requestLeave]
  );

  return {
    confirmOpen,
    confirmLeave,
    cancelLeave,
    handleBackdropClick,
    requestLeave,
  };
}
